import Vue from 'vue'
import Router from 'vue-router'
// 引入一级组件
import Footer from '../components/common/Footer'
import Header from '../components/common/Header'
import Home from '../views/HomePage'
import Information from '../views/Information'
import Info from '../views/Info'
import Enter from '../views/Enter'
import aboutus from '../views/aboutus'
import Electricity from '../views/Electricity'
import Register from '../views/Register'
import Statement from '../views/Statement.vue'
import Product from '../views/Product.vue'
import Platform from '../views/Platform.vue'
import Details from '../views/Details.vue'
import refresh from '../views/refresh.vue'


Vue.use(Router)
Vue.component('Header', Header)
Vue.component('Footer', Footer)

// 懒加载二级组件 Tarbar
const HomePage = () => import('../views/HomePage')



export default new Router({
  //页面跳转置顶
  scrollBehavior (to,from,saveTop){
    if(saveTop){
      return saveTop
    }else{
      return {x:0,y:0}
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/homePage',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/information',
      name: 'Information',
      component: Information
    },
    {
      path: '/info',
      name: 'Info',
      component: Info
    },
    {
      path: '/enter',
      name: 'Enter',
      component: Enter
    },
    {
    	path: '/aboutus',
    	name: 'aboutus',
    	component: aboutus
    },
    {
      path: '/electricity',
    	name: 'Electricity',
    	component: Electricity
    },
    {
      path: '/register',
    	name: 'Register',
    	component: Register
    },
    {
      path: '/statement',
    	name: 'Statement',
    	component: Statement
    },
    {
      path: '/product',
    	name: 'Product',
    	component: Product
    },
    {
      path: '/platform',
    	name: 'Platform',
    	component: Platform
    },
    {
      path: '/details',
    	name: 'Details',
    	component: Details
    },
    {
      path: '/refresh',
    	name: 'refresh',
    	component: refresh
    },

  ],
mode: 'history'
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js